import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// The _spc modifiers are the single-page checkout's left-aligned layout; /products keeps the centred heading.
const AddressHeading = ({ title, address, onResetAddress, isExistingCustomer, currentTfn, isSinglePageCheckout = false }) => {
  const { t } = useTranslation();
  const telHref = currentTfn ? `tel:${currentTfn.replace(/[^0-9]/g, '')}` : undefined;
  return (
    <div className={`elnk-internet-heading${isSinglePageCheckout ? ' elnk-internet-heading_spc' : ''}`}>
      <h1 className={`elnk-internet-heading__title${isSinglePageCheckout ? ' elnk-internet-heading__title_spc' : ''}`}>{title}</h1>
      <p className={`elnk-internet-heading__address${isSinglePageCheckout ? ' elnk-internet-heading__address_spc' : ''}`}>
        <span className="address-txt">{address}</span>
        <button className="address-btn" type="button" onClick={onResetAddress}>
          <i className="fa-solid fa-pen-to-square address-edit-icon" aria-hidden="true"></i> {t('products.editAddress')}
        </button>
      </p>
      {isExistingCustomer && currentTfn && <p className={`elnk-internet-heading__existing${isSinglePageCheckout ? ' elnk-internet-heading__existing_spc' : ''}`}>{t('products.existingCustomerContact')} <a href={telHref} className="elnk-tfn-link">{currentTfn}</a></p>}
    </div>
  );
};

AddressHeading.propTypes = {
  title: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  onResetAddress: PropTypes.func.isRequired,
  isExistingCustomer: PropTypes.bool,
  currentTfn: PropTypes.string,
  isSinglePageCheckout: PropTypes.bool,
};

export default AddressHeading;
